import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, IconFullScreen, Modal } from '../../components';

import css from './ListingPage.module.css';

const SectionVideos = props => {
  const { videos, onManageDisableScrolling } = props;

  if (!videos?.length) return null;

  const [isOpen, setIsOpen] = useState(false)
  const [videoSrc, setVideoSrc] = useState(null)

  // const onOpenPopup = (src) => {
  //   setIsOpen(true)
  //   setVideoSrc(src)
  // }

  // const onClosePopup = () => {
  //   setIsOpen(false)
  //   setVideoSrc(null)
  // }

  return (
    <section className={css.sectionVideos}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.videosTitle" />
      </Heading>

      <div className={css.videos}>

        {videos?.length && videos.map(v => {
          return (
            <div key={v.key} className={css.videoHolder}>
              <video controls className={css.video}>
                <source src={v.location} type={`video/mp4`} />
                Your browser does not support the video tag.
              </video>

              {/* <button className={css.fullWidthVideo} onClick={() => onOpenPopup(v.location)}>
                <IconFullScreen />
              </button> */}
            </div>
          )
        })}
      </div>

      {/* <Modal
        id="ListingPage.SectionVideos"
        isOpen={isOpen}
        onClose={() => onClosePopup()}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        containerClassName={css.popupVideoContainer}
      >
        <div className={css.popupVideoWrapper}>
          {videoSrc && (
            <video controls className={css.popupVideo}>
              <source src={videoSrc} type={`video/mp4`} />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </Modal> */}
    </section>
  );
};

export default SectionVideos;
